export default class FontUtil {

    sampleFontParings() {
        return [
            {display: 'Lato', body: 'Merriweather'},
            {display: 'Open Sans', body: 'Bitter'},
            {display: 'Montserrat', body: 'Open Sans'},
            {display: 'Raleway', body: 'Lato'},
            {display: 'Roboto', body: 'Source Sans Pro'},
            {display: 'Oswald', body: 'Lato'},
            {display: 'PT Sans', body: 'PT Serif'},
            {display: 'Merriweather', body: 'Open Sans'},
            {display: 'Playfair Display', body: 'Open Sans'},
            {display: 'Lora', body: 'Open Sans'},
            {display: 'Fira Sans', body: 'Source Sans Pro'},
            {display: 'Ubuntu', body: 'Lato'},
        ]
    }

    funFontPairings() {
        return [
            {display: 'Pacifico', body: 'Dancing Script'},
            {display: 'Great Vibes', body: 'Lobster'},
            {display: 'Amatic SC', body: 'Satisfy'},
            {display: 'Quicksand', body: 'Sacramento'},
            {display: 'Playfair Display', body: 'Yanone Kaffeesatz'},
        ]
    }

    loadFonts(theme, availableFontList) {
        let font = theme.metadata.displayFont
        let weights = webase.utils.ui.availableWeights(availableFontList, font.family).join(';')
        weights = weights.replace('regular', '400')
        webase.utils.ui.injectFont(font.family, ':wght@' + weights)

        font = theme.metadata.textFont
        weights = webase.utils.ui.availableWeights(availableFontList, font.family).join(';')
        weights = weights.replace('regular', '400')
        webase.utils.ui.injectFont(font.family, ':wght@' + weights)
    }

    fontStyle(font) {
        let weight = font.weight

        let fontStyle = {
            fontFamily: font.family,
            fontWeight: weight === 'regular' ? '400' : weight,
        }
        return fontStyle
    }

    loadThemeFonts(theme) {
        if (theme.header_font && theme.header_font.family) {
            this.loadFont(theme.header_font.family)
        }

        if (theme.text_font && theme.text_font.family) {
            this.loadFont(theme.text_font.family)
        }
    }

    loadPreview(fontFamily) {
        let availableWeights = webase.utils.ui.availableWeights(webase.model.fonts, fontFamily)
        let weights = availableWeights.join(';')
        weights = weights.replace('regular', '400')
        webase.utils.ui.injectFontPreview(fontFamily, ':wght@' + weights)
    }

    loadFont(fontFamily) {
        let availableWeights = webase.utils.ui.availableWeights(webase.model.fonts, fontFamily)
        let weights = availableWeights.join(';')
        weights = weights.replace('regular', '400')
        webase.utils.ui.injectFont(fontFamily, ':wght@' + weights)
    }
}